"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
const react_1 = __importDefault(require("react"));
const Form = ({ children, onSubmit, className }) => {
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit?.(e);
    };
    return (react_1.default.createElement("form", { onSubmit: handleSubmit, className: className, "aria-label": "form" }, children));
};
exports.Form = Form;
